'use client'

type CookieSettingsButtonProps = {
  label: string
}

export function CookieSettingsButton({ label }: CookieSettingsButtonProps) {
  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window !== 'undefined') {
          window.UC_UI?.showSecondLayer()
        }
      }}
    >
      {label}
    </button>
  )
}
